var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmaliSaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meh",
    transform: "translate(1.488 1.763)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(0.012 -0.263)",
    fill: "none",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    x2: 15,
    transform: "translate(10.012 22.737)",
    fill: "none",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    transform: "translate(12.012 12.737)",
    fill: "none",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    transform: "translate(23.012 12.737)",
    fill: "none",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmaliSaidIcon);
export default __webpack_public_path__ + "static/media/smaliSaidIcon.4c7441ab40f410cbaed4d2e096a61311.svg";
export { ForwardRef as ReactComponent };